import { CdkStepperModule } from '@angular/cdk/stepper';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreUiModule } from '../../core-ui/core-ui.module';
import { StepperComponent } from './stepper.component';

@NgModule({
    imports: [CommonModule, CoreUiModule, CdkStepperModule],
    declarations: [StepperComponent],
    exports: [StepperComponent],
    providers: []
})
export class StepperModule {}
